import { apiUrl } from "app/config";
import { getHeaderJwtJson } from "helpers/FetchHelper";
import { IGetTasks, IMyTasksFilter, ITaskFields, ITasksFilter } from "shared/ui/layout/types";
import { generateUrlParams } from "helpers/functions/tranformText";

import {
  IDocumentGet,
  IDocumentGetFilter,
} from "features/documents/types/types";
import { ITableModel } from "helpers/types/types";
const TasksUrl = apiUrl + "tasks/";
const MapForm = (formData: ITaskFields, selectObserver: string[]) => {
  return { ...formData, observers: selectObserver };
};

export const getTasks = async (
  filterValue: ITasksFilter | IMyTasksFilter,
  isMyTask?: boolean
): Promise<IGetTasks | undefined> => {
  const Url = TasksUrl + (isMyTask === true ? "myTask" : "list");
  const responce = await fetch(Url, {
    method: "POST",
    headers: getHeaderJwtJson(),
    body: await JSON.stringify(filterValue ?? ({} as ITasksFilter)),
  });
  let data = (await responce.json()) as IGetTasks;
  return responce.ok ? data : undefined;
};

export async function GetTask(id: string) {
  const url = TasksUrl + id;
  const responce = await fetch(url, {
    method: "GET",
    headers: getHeaderJwtJson(),
  });
  if (responce.ok === true) {
    let data = await responce.json();
    return data;
  }
  return false;
}

export async function deleteTask(id: string) {
  const url = TasksUrl + id + "/delete";
  const responce = await fetch(url, {
    method: "GET",
    headers: getHeaderJwtJson(),
  });
  if (responce.ok === true) {
    return true;
  }
  return false;
}

export async function AddTask(dataForm: ITaskFields, selectObserver: string[]) {
  var url = TasksUrl + "create";
  const responce = await fetch(url, {
    method: "POST",
    headers: getHeaderJwtJson(),
    body: JSON.stringify(MapForm(dataForm, selectObserver)),
  });
  if (responce.ok === true) {
    return true;
  }
  return false;
}

export async function EditTask(
  dataForm: ITaskFields,
  selectObserver: string[]
) {
  var url = TasksUrl + dataForm.id + "/update";
  const responce = await fetch(url, {
    method: "POST",
    headers: getHeaderJwtJson(),
    body: JSON.stringify(MapForm(dataForm, selectObserver)),
  });
  if (responce.ok === true) {
    return true;
  }
  return false;
}

export async function deleteComment(id: string) {
  const url = TasksUrl + id + "/commentDelete";
  const responce = await fetch(url, {
    method: "GET",
    headers: getHeaderJwtJson(),
  });
  if (responce.ok === true) {
    return true;
  }
  return false;
}

export async function AddComment(dataForm: any) {
  var url = TasksUrl + "commentCreate";
  const responce = await fetch(url, {
    method: "POST",
    headers: getHeaderJwtJson(),
    body: JSON.stringify(dataForm),
  });
  if (responce.ok === true) {
    return true;
  }
  return false;
}

export async function EditComment(dataForm: any, id: string) {
  var url = TasksUrl + id + "/commentUpdate";
  const responce = await fetch(url, {
    method: "POST",
    headers: getHeaderJwtJson(),
    body: JSON.stringify(dataForm),
  });
  if (responce.ok === true) {
    return true;
  }
  return false;
}

export async function addLink(dataForm: any, id: string) {
  const url = TasksUrl + "linkCreate";
  dataForm.TaskId = id;
  const responce = await fetch(url, {
    method: "POST",
    headers: getHeaderJwtJson(),
    body: JSON.stringify(dataForm),
  });
  if (responce.ok === true) {
    return true;
  }
  return false;
}

export async function deleteLink(id: string) {
  const url = TasksUrl + id + "/linkDelete";
  const responce = await fetch(url, {
    method: "GET",
    headers: getHeaderJwtJson(),
  });
  if (responce.ok === true) {
    return true;
  }
  return false;
}

//TODO: Удалить, работать с методом из /documents/fetch
export async function getDocuments(
  categoryId: string,
  filter: IDocumentGetFilter
): Promise<ITableModel<IDocumentGet> | undefined> {
  const url = `${apiUrl}documents/list/${categoryId}?${generateUrlParams(
    "Filter",
    filter
  )}`;
  const responce = await fetch(url + categoryId, {
    method: "GET",
    headers: getHeaderJwtJson(),
  });
  let data = await responce.json();
  return responce.ok ? data : undefined;
}
